<!--
        Las paginas para administrar Listas
-->
<div class="page" id="list-collection-page">
    <div class="action-bar dark-bg with-tabs">
            <div class="title">Listas</div>
            <div class="tabs">
                <a class="tab" href="#listas?estado=A">Activas</a>
                <a class="tab" href="#listas?estado=I">Inactivas</a>
                <a class="tab" href="#listas?estado=X">Eliminadas</a>
                <a class="tab" href="#listas?estado=*">Todas</a>
            </div>
            <div class="actions-set">
                <a class="action-btn back" href="#home"></a>
                <a class="action-btn search" href="#"></a>
                <a class="action-btn add" href="#lista?id=nuevo">Agregar una nueva lista</a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
    </div>
    <div class="content">
        <div class="container">
            <div class="section" id="listas">
                <div class="list-content"></div>
            </div>
        </div>
    </div>
</div>

<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#list-collection-page").ListCollectionPage("#listas");
  console.log("DONE: installed ListsCollectionPage to hash '#listas'")
})
</script>
